import { useParams } from 'react-router-dom';
import { useQuote } from '@services/quotes/useQuote';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';

export const useRelatedTransactionsData = () => {
  const { quoteId } = useParams<{ quoteId: string }>();
  const { quote, isLoading: isQuoteLoading } = useQuote(quoteId);
  const { isInternalUser } = useStore((state) => state.userAuth, shallow);

  const customerId = quote?.customer?.id;
  const policyId = quote?.policyId;
  const currentTransactionId = quote?.policyTransaction?.id;
  const hasPolicyTransaction = !!quote?.policyTransaction;

  return {
    quoteId,
    quote,
    customerId,
    policyId,
    currentTransactionId,
    hasPolicyTransaction,
    isInternalUser,
    isQuoteLoading,
  };
};
